export class ChangeRGBA {
    constructor(slotId) {
        this.slotId = slotId;
    }
    apply(frame, vb, slots) {
        this.updateVB(vb, slots);
        return frame >= this.startFrame;
    }
    initChange(vb) {
        this.sizeMap = vb.slotVBMap.get(this.slotId);
        return true;
    }
    updateVB(vb, slots) {
        if (!this.sizeMap) {
            this.sizeMap = vb.slotVBMap.get(this.slotId);
            if (!this.sizeMap) {
                return false;
            }
        }
        let slot = slots[this.slotId];
        let color = slot.color;
        if (slot.attachment) {
            let vertexSize = vb.vertexSize;
            let attachmentPos = this.sizeMap.get(slot.attachment.name);
            let vbData = vb.vb;
            let offset = attachmentPos.offset * vertexSize;
            let attachment = attachmentPos.attachment;
            let r, g, b, a;
            let attachmentColor = attachment.lightColor;
            let twoColorTint = vb.twoColorTint;
            let colorElement = vb.vertexDeclaration.getVertexElementByUsage(1);
            let cOffset = colorElement.offset / 4;
            let c2Offset = 0;
            if (twoColorTint) {
                let color2Element = vb.vertexDeclaration.getVertexElementByUsage(11);
                c2Offset = color2Element.offset / 4;
            }
            if (!attachmentColor) {
                r = color.r;
                g = color.g;
                b = color.b;
                a = color.a;
            }
            else {
                r = color.r * attachmentColor.r;
                g = color.g * attachmentColor.g;
                b = color.b * attachmentColor.b;
                a = color.a * attachmentColor.a;
            }
            let darkColor = slot.darkColor;
            let darkColorR = 0, darkColorG = 0, darkColorB = 0, darkColorA = 1;
            if (darkColor) {
                darkColorR = darkColor.r;
                darkColorG = darkColor.g;
                darkColorB = darkColor.b;
                darkColorA = darkColor.a;
            }
            let n = attachment.vertexCount;
            for (let i = 0; i < n; i++) {
                let co = offset + i * vertexSize + cOffset;
                vbData[co] = r;
                vbData[co + 1] = g;
                vbData[co + 2] = b;
                vbData[co + 3] = a;
                if (twoColorTint) {
                    let c2o = offset + i * vertexSize + c2Offset;
                    vbData[c2o] = darkColorR;
                    vbData[c2o + 1] = darkColorG;
                    vbData[c2o + 2] = darkColorB;
                    vbData[c2o + 3] = darkColorA;
                }
            }
        }
        return true;
    }
    clone() {
        let out = new ChangeRGBA(this.slotId);
        out.startFrame = this.startFrame;
        out.endFrame = this.endFrame;
        return out;
    }
}
